export default __webpack_public_path__ + "static/logo-98c2ce1bb1abd03f3bd78913d3ee032e.svg";